<div class="h-full w-full">
    <iframe #externalFrame [src]="safeUrl" (load)="onIframeLoad()" class="h-full w-full"> </iframe>
</div>
